const BaseModel = require('./BaseModel');

class MessageTemplate extends BaseModel {
  static basePath = '/api/v1/templates';
  static dataType = 'message-template';

  constructor(json={}) {
    super(json);

    this.parseChildren(['flow', 'template']);
  }
}

BaseModel.models[MessageTemplate.dataType] = MessageTemplate;
module.exports = MessageTemplate;
